import React from 'react';
import {findDOMNode} from "react-dom";
import PropTypes from 'prop-types';

import Popover from '../../gd-components/gd-popover/popover';
import {ProjectIconsOptionsList} from "core/gd/const/item-icon/project";
import {DocIconOptions} from "core/gd/const/item-icon/doc";
import {TaskIconOptions} from "core/gd/const/item-icon/task";

export default class SelectIcon extends React.Component {

    static propTypes = {

        value: PropTypes.string,                        // current value
        // options: PropTypes.array,                    // not in use IF needed in the future us it ?
        iconType: PropTypes.string.isRequired,                     // [project, task] should be passed

        // callbacks
        onUserSelect: PropTypes.func,
        onChange: PropTypes.func,
        onTogglePopover: PropTypes.func, // to track if any popover opened from this component

        // look and feel
        renderValue: PropTypes.oneOf(['default', 'form', 'func']).isRequired, // render value view name
        renderValueFunc: PropTypes.func,        // func for external render function if passwed used to render instead of default

        disabled: PropTypes.bool,                       // if true not editable (!) just view maybe right name is editable not disabled ?

        // form - if passed component will act as form element
        form: PropTypes.object,
        name: PropTypes.string,

        attachment: PropTypes.string,
        targetAttachment: PropTypes.string,
        targetOffset: PropTypes.string,
        attachmentType: PropTypes.string,
    };

    static defaultProps = {
        renderValue: 'default',
        disabled: false,

        attachment: "top center",
        targetAttachment: "bottom center",
        targetOffset: "0 0",

        constraints: [{
            to: "window",
            attachment: "together"
        }]
    };

    constructor(props) {
        super(props);
        const { value, form, name } = props;

        // icon options
        this.options = [];
        switch (this.props.iconType) {
            case 'task':
                // this.options = gd.const.ii.taskIcons;
                this.options = TaskIconOptions
                break;

            case 'project':
                this.options = ProjectIconsOptionsList
                break;

            case 'note':
                // this.options = gd.const.ii.docIcons;
                this.options = DocIconOptions
                break;

            default: console.error("unknown icon type",'type=', props.iconType); break;
        }

        this.state = {
            showPopover: false,
            value: form ? form.getValue(name) : value
        };
    }

    UNSAFE_componentWillMount() {
        if (this.props.form) this.props.form.registerFormComponent(this.props.name,this);
    }

    // if rerender with new value
    UNSAFE_componentWillReceiveProps(nextProps){
        // when form value changed and we re-render the whole thing
        if (nextProps.form) {
            const formValue = nextProps.form.getValue(nextProps.name);
            if (this.state.value !== formValue) this.setValue(formValue);
        } else {
            if (typeof nextProps.value !== 'undefined' && nextProps.value !== this.state.value) {
                this.setState({
                    value: nextProps.value
                });
            }
        }
    }

    preventPropagation = (e) => {
        e.stopPropagation();
    }

    togglePopover = () => {
        if (!this.props.disabled) {
            const showPopover = !this.state.showPopover;
            this.setState({
                showPopover: showPopover
            },()=>{
                if (this.props.onTogglePopover) this.props.onTogglePopover(showPopover);
            });
        }
    }

    hidePopover = (value) => {
        this.setState({
            showPopover: false,
            value: value ? value : this.state.value
        }, ()=>{
            if (this.props.onTogglePopover) this.props.onTogglePopover(false);
        });
    }

    onIconClick = (value) => {
        // process form
        if (this.props.form) this.props.form.onFormComponentValueChange(this.props.name, value);

        this.hidePopover(value);

        if (this.props.onUserSelect) this.props.onUserSelect(value, this.confirmCallback);
    }

    confirmCallback = (value) => {
        let prevValue = this.state.value;
        this.setState({
            showPopover: false,
            value: value
        }, ()=>{
            if (this.props.onChange) this.props.onChange(prevValue, value);
        });
    }

    renderPopover() {
        if (!this.state.showPopover) return false;

        return (
            <Popover popoverClass=""
                     attachment={this.props.attachment}
                     targetAttachment={this.props.targetAttachment}
                     targetOffset={this.props.targetOffset}
                     constraints={this.props.constraints}
                     onClickOutside={()=>{this.hidePopover()}}
                     attachmentType={this.props.attachmentType}
                     heightRestriction="half-window-height"
                     getTargetFunc={()=>findDOMNode(this)}>

                <div className="ui5-popover-selector icon-selector">


                    {this.options.map((group, key)=>
                        <div className="icons-group" key={key}>
                            {group.map((option, key)=>
                                <div className="block" key={key} onClick={this.onIconClick.bind(this, option)}>
                                    <div className={"icon "+gd.const.ii[option]}> </div>
                                </div>
                            )}
                        </div>
                    )}

                </div>
            </Popover>
        );
    }

    renderValue() {
        // let selectedIcon = false;
        // if (this.state.value) {
        //     this.options.forEach((o)=>{
        //         if (o.value === this.state.value) {
        //             selectedIcon = o.icon;
        //         }
        //     });
        // }
        const selectedIcon = gd.const.ii[this.state.value];
        let iconClass = Classes("icon", selectedIcon);

        switch (this.props.renderValue) {

            case 'default':
                return (
                    <div className="cur-value" onClick={this.togglePopover}>
                        <div className={iconClass}/>
                    </div>
                );

            case 'form':
                return (
                    <div className="cur-value" onClick={this.togglePopover}>
                        <div className={iconClass}/>
                        <div key="arrow" className="arrow-icon i5-big-angle-down" />
                    </div>
                );

            case 'func':
                return (
                    <div className="cur-value" onClick={this.togglePopover}>
                        {this.props.renderValueFunc(this.state.value)}
                    </div>
                );
        }
    }

    render() {
        const classes = Classes('gd-select-icon', 'render-'+this.props.renderValue, this.props.className, {
            // 'disabled': this.props.disabled,
            'open': this.state.showPopover,
        });

        return (
            <div className={classes} onClick={this.preventPropagation}>
                {this.renderValue()}
                {this.renderPopover()}
            </div>
        );
    }
}